module.exports = __webpack_public_path__ + "static/media/22ESCWA12.db090c78.jpg";